export const AUTH_TOKEN = 'auth/TOKEN';
export const AUTH_LOADING = 'auth/LOADING';
export const AUTH_SUCCESS = 'auth/SUCCESS';
export const AUTH_ERROR = 'auth/ERROR';
export const AUTH_LOGOUT = 'auth/LOGOUT';
export const AUTH_TOKEN_KEY = 'podlink/token'